import api from './api';

const BASE = '/platform/data-import';

const unwrap = (response) => response?.data;

export const fetchTenantImportTables = async (tenantId, options = {}) =>
  unwrap(await api.get(`${BASE}/tables`, {
    params: {
      tenant_id: tenantId,
      table: options.table || undefined,
      include_lookup_options: options.includeLookupOptions ? 1 : undefined,
    },
  }));

export const previewTenantDataImport = async ({
  tenantId,
  table,
  file,
  headingRow = 1,
  sheetIndex = 0,
}) => {
  const formData = new FormData();
  formData.append('tenant_id', tenantId);
  formData.append('table', table);
  formData.append('file', file);
  formData.append('heading_row', headingRow);
  formData.append('sheet_index', sheetIndex);

  return unwrap(await api.post(`${BASE}/preview`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }));
};

export const runTenantDataImport = async ({
  tenantId,
  table,
  importId,
  headingRow = 1,
  sheetIndex = 0,
  mode = 'insert',
  uniqueBy = '',
  mappings,
}) =>
  unwrap(await api.post(`${BASE}/run`, {
    tenant_id: tenantId,
    table,
    import_id: importId,
    heading_row: headingRow,
    sheet_index: sheetIndex,
    mode,
    unique_by: uniqueBy || null,
    mappings,
  }));

const platformDataImportApi = {
  fetchTenantImportTables,
  previewTenantDataImport,
  runTenantDataImport,
};

export default platformDataImportApi;
